// extracted by mini-css-extract-plugin
export default {"linkButton":"LinkButton_linkButton__DqY9Z","disabled":"LinkButton_disabled__r8Dhl"};